<template>
    <div class="setup">
        <b-loading :is-full-page="isFullPage" :active.sync="showLoader"></b-loading>
        <form action="" class="form setup-form-block">
            <div class="form-content-block group" v-bind:class="fieldConfigs.visitor_type.fieldClass">
                <div class="row">
                    <label class="radio input-label"
                        v-for="(option, index) in fieldConfigs.visitor_type.options"
                        v-bind:key="index">
                        <input
                            type="radio"
                            v-model="formData.visitor_type"
                            v-bind:id="'radio-visitor-type-' + index"
                            v-bind:value="option.value"
                            v-validate="fieldConfigs.visitor_type.validations.rule"
                            v-bind:name="fieldConfigs.visitor_type.name"
                            />
                        {{ option.label }}
                    </label>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { each, isEqual } from 'lodash';
import settingsFormMixins from 'SrcRoot/mixins/form/settings_form';
import {unsavedChangesTitle, unsavedChangesSubtitle} from 'SrcRoot/mixins/modal';
import modalMixins from 'SrcRoot/mixins/modal';
import { initEcommerceVisitorSegmentData, initB2BMediaVisitorSegmentData,initEcommerceReturningCustomerSegmentation } from './scripts/init';

export default {
    name: 'VisitorSegment',
    mixins: [
        settingsFormMixins,
        modalMixins,
        //formMixins
    ],
    components: {
        
    },
    computed: {
        ...mapGetters("campaigns", [
            "currentCampaign",
        ]),
        ...mapGetters('authentication', [
            'company'
        ]),
        /*...mapState('settings', {
            company: (state) => state.company
        }),*/
        visitor_segment() {
            return this.currentCampaign.settings.visitor_segment;
        },
        customer_industry_category() { // eCommerce
            const {company} = this.currentCampaign;
            if (company === undefined) {
                return;
            } else {
                const {customer_type} = company;
                if (customer_type === undefined) {
                    return;
                } else {
                    return customer_type.customer_type;
                }
            }
        }
    },
    /*beforeRouteLeave(to, from, next) {
        this.gotonextroute = next;
        //this.saveVisitorSegmentation(next);
    },*/
    data() {
        return {
            formData: {},
            fieldConfigs: {},
            isFullPage: false,
            showLoader: false,
            showError:false,
            returningVisitorSegmentationFieldConfigs:{},
            unsavedChangesTitle,
            unsavedChangesSubtitle,
            thisComponent:this,
            showDialog:false,
            validationErrorMsg: "",
            gotonextroute: ""
        };
    },
    created() {
        this.initComponentData();
        this.fetchVisitorSegmentData();
    },
    methods: {
        initComponentData() {
            let data, fieldConfigurations, eCommerceInitData, b2MediaInitData;
            eCommerceInitData = initEcommerceVisitorSegmentData();
            b2MediaInitData = initB2BMediaVisitorSegmentData(); 

            if (this.customer_industry_category === 'eCommerce')
                ({data, fieldConfigurations} = eCommerceInitData);
            else 
                ({data, fieldConfigurations} = b2MediaInitData);

            this.formData = {
                ...data
            };

            this.fieldConfigs = {
                ...fieldConfigurations
            };

            const returningCustomerSegmentationData = initEcommerceReturningCustomerSegmentation();

            let returning_visitor_segmentation = [];
            each(returningCustomerSegmentationData.fieldConfigurations.options, (config) => {
                let form_data_item = {
                    select: config.select,
                    returning_visitor_segment_type: config.name
                };
                returning_visitor_segmentation.push(form_data_item);
            });
            this.formData = {
                ...this.formData,
                ...data,
                returning_visitor_segmentation
            };

            this.returningVisitorSegmentationFieldConfigs = {
                ...this.returningVisitorSegmentationFieldConfigs,
                ...returningCustomerSegmentationData.fieldConfigurations
            };
        },
        fetchVisitorSegmentData() {
            this.showLoader = true;
            return this
                .$store
                .dispatch('campaigns/getVisitorSegment', {
                    data: {
                        campaign_id: this.currentCampaign.id,
                    }
                })
                .then(() => {
                    this.showLoader = false;
                });
        },
        saveVisitorSegmentation(next) {
            this.showLoader = true; 
            return this
                .$store
                .dispatch('campaigns/addOrUpdateVisitorSegment', {
                    data: {
                        campaign_id: this.currentCampaign.id,
                        formData: this.formData
                    }
                })
                .then(() => {
                    this.showLoader = false;
                    if (typeof next === 'function') {
                        next();
                    }
                })
        },
        mapVisitorSegmentdata() {
            this.formData = {
                ...this.formData,
                ...this.visitor_segment
            };
        },
        isComponentDirty() {
            return false;
        }
    },
    watch: {
        visitor_segment(to, from) {
            if (to === undefined) {
                return;
            }
            this.mapVisitorSegmentdata();
        },
        'formData.visitor_type'(to, from) {
            if (from === undefined || to === undefined || from == to) {
                return;
            }
            this.saveVisitorSegmentation();
        },
        
    }
}
</script>
<style lang="scss" scoped>
@import "SrcRoot/modules/Campaign/components/setup/scss/setup.scss";

</style>
